import { 
    LinkCreationErrorCode,
    LinkCreationException 
} from 'phoenix/domain/link-creation-exception';

export class LinkCreationExceptionFactory{
    public static $inject = [
        'gettextCatalog'
    ];

    constructor(public gettextCatalog:ng.gettext.gettextCatalog){}

    public create(errorCode:LinkCreationErrorCode, message?:string){
        return new LinkCreationException(
            this.gettextCatalog,
			errorCode,
			message
        );
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/factories/link-creation-exception-factory.ts